import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TypeWithCustomer.css';
import { FaCheckSquare, FaPlus } from 'react-icons/fa'; // Corrected imports

function TypeWithCustomer() {
  const [vendors, setVendors] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [products, setProducts] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerNumbers, setSelectedCustomerNumbers] = useState([]);
  const [message, setMessage] = useState('');
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [previewVisible, setPreviewVisible] = useState(false); // New state for preview

  useEffect(() => {
    if (token) {
      const decodedToken = decodeToken(token);
      console.log('Decoded token:', decodedToken);
      if (decodedToken && decodedToken.vendorId) {
        const vendorId = Number(decodedToken.vendorId);
        if (isNaN(vendorId)) {
          setError('Invalid vendor ID from token');
          return;
        }
        setSelectedVendorId(vendorId);
        fetchProducts(vendorId);
      }
      fetchVendors();
      fetchCustomers();
    }
  }, [token]);

  const decodeToken = (token) => {
    try {
      const [header, payload, signature] = token.split('.');
      const decodedPayload = JSON.parse(atob(payload));
      return decodedPayload;
    } catch (err) {
      console.error('Token decode error:', err);
      return null;
    }
  };

  const fetchVendors = async () => {
    try {
      const res = await axios.get('http://localhost:5002/api/vendors', { headers: { Authorization: `Bearer ${token}` } });
      console.log('Vendors response:', res.data);
      setVendors(res.data);
    } catch (err) {
      console.error('Fetch vendors error:', err.response?.data || err);
      setError('Failed to fetch vendors: ' + (err.response?.data?.details || err.response?.data?.error || err.message));
    }
  };

  const fetchCustomers = async () => {
    try {
      const res = await axios.get('http://localhost:5002/api/customers', { headers: { Authorization: `Bearer ${token}` } });
      setCustomers(res.data);
    } catch (err) {
      setError('Failed to fetch customers: ' + (err.response?.data?.details || err.response?.data?.error || err.message));
    }
  };

  const fetchProducts = async (vendorId) => {
    try {
      if (!vendorId || isNaN(Number(vendorId))) {
        setError('Invalid vendor ID for products fetch');
        return;
      }
      const res = await axios.get(`http://localhost:5002/api/products?vendorId=${vendorId}`, { headers: { Authorization: `Bearer ${token}` } });
      console.log('Products response:', res.data); // Debug log
      setProducts(res.data);
    } catch (err) {
      setError('Failed to fetch products: ' + (err.response?.data?.details || err.response?.data?.error || err.message));
    }
  };

  const handleSendMessage = async () => {
    if (!selectedVendorId || isNaN(Number(selectedVendorId)) || selectedProductIds.length === 0 || selectedCustomerNumbers.length === 0 || !message) {
      setError('Please fill all fields with valid IDs, select at least one product and customer!');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await axios.post(
        'http://localhost:5002/api/whatsapp/send',
        {
          vendorId: Number(selectedVendorId),
          productIds: selectedProductIds,
          customerNumbers: selectedCustomerNumbers,
          message,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const vendor = vendors.find(v => v.id === Number(selectedVendorId));
      const selectedProducts = products.filter(p => selectedProductIds.includes(String(p.id)));
      setSentMessages([...sentMessages, {
        vendorName: vendor.shopName,
        products: selectedProducts,
        customerNumbers: selectedCustomerNumbers,
        message,
      }]);
      setMessage('');
      setSelectedProductIds([]);
      setSelectedCustomerNumbers([]);
      alert('Message sent successfully!');
    } catch (err) {
      setError('Failed to send message: ' + (err.response?.data?.details || err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const email = prompt('Enter email');
    const password = prompt('Enter password');
    axios
      .post('http://localhost:5002/api/auth/login', { email, password })
      .then(res => {
        setToken(res.data.token);
        localStorage.setItem('token', res.data.token);
      })
      .catch(err => alert(err.response?.data?.error || 'Network Error: Please try again'));
  };

  const [sentMessages, setSentMessages] = useState([]);

  if (!token) return (
    <div className="login-prompt">
      <h2>Please Login</h2>
      <button onClick={handleLogin}>Login</button>
    </div>
  );

  const handleSelectAllCustomers = () => {
    setSelectedCustomerNumbers(customers.map(c => c.phoneNumber));
  };

  const handleSelectTenCustomers = () => {
    const tenCustomers = customers.slice(0, 10).map(c => c.phoneNumber);
    setSelectedCustomerNumbers(tenCustomers);
  };

  const handleSelectAllProducts = () => {
    setSelectedProductIds(products.map(p => String(p.id)));
  };

  const handleSelectTenProducts = () => {
    const tenProducts = products.slice(0, 10).map(p => String(p.id));
    setSelectedProductIds(tenProducts);
  };

  const handlePreviewWhatsAppCard = () => {
    // Use the last sent message if available, otherwise use current selections
    const lastSentMessage = sentMessages.length > 0 ? sentMessages[sentMessages.length - 1] : null;
    setPreviewVisible(true);
  };

  const selectedProducts = products.filter(p => selectedProductIds.includes(String(p.id)));

  return (
    <div className="type-with-customer">
      <h1>Send Message to Customers</h1>
      {error && <p className="error">{error}</p>}
      <div className="form-group">
        <label>Logged-in Vendor:</label>
        <div className="vendor-info">
          <input
            type="text"
            value={vendors.find(v => v.id === Number(selectedVendorId))?.shopName || (vendors.length === 0 ? 'Loading...' : 'Vendor not found')}
            className="input-field"
            readOnly
            title={vendors.length > 0 ? JSON.stringify(vendors) : 'No vendors fetched'}
          />
          {vendors.find(v => v.id === Number(selectedVendorId))?.shopImage && (
            <img
              src={`http://localhost:5002${vendors.find(v => v.id === Number(selectedVendorId))?.shopImage}`}
              alt={vendors.find(v => v.id === Number(selectedVendorId))?.shopName || 'Vendor Image'}
              className="vendor-image"
              style={{ maxWidth: '100px', maxHeight: '100px' }}
              onError={(e) => console.log('Vendor Image Error:', e.target.src)}
            />
          )}
        </div>
      </div>
      <div className="form-group">
        <label>Select Product:</label>
        <div className="product-list">
          <div className="product-actions">
            <button onClick={handleSelectAllProducts} className="action-btn"><FaCheckSquare /> Select All</button>
            <button onClick={handleSelectTenProducts} className="action-btn"><FaPlus /> Select 10</button>
          </div>
          {products.map(product => (
            <label key={product.id} className="product-item">
              <input
                type="checkbox"
                value={product.id}
                checked={selectedProductIds.includes(String(product.id))}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedProductIds([...selectedProductIds, e.target.value]);
                  } else {
                    setSelectedProductIds(selectedProductIds.filter(id => id !== e.target.value));
                  }
                }}
              />
              <span>{product.name} - ₹{product.price}</span>
              {product.image && (
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                  style={{ maxWidth: '50px', maxHeight: '50px', marginLeft: '10px' }}
                  onError={(e) => console.log('Product Image Error:', e.target.src)}
                />
              )}
            </label>
          ))}
        </div>
      </div>
      <div className="form-group">
        <label>Select Customers:</label>
        <div className="customer-list">
          <div className="customer-actions">
            <button onClick={handleSelectAllCustomers} className="action-btn"><FaCheckSquare /> Select All</button>
            <button onClick={handleSelectTenCustomers} className="action-btn"><FaPlus /> Select 10</button>
          </div>
          {customers.length > 0 ? (
            customers.map(customer => (
              <label key={customer.phoneNumber} className="customer-item">
                <input
                  type="checkbox"
                  value={customer.phoneNumber}
                  checked={selectedCustomerNumbers.includes(customer.phoneNumber)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedCustomerNumbers([...selectedCustomerNumbers, customer.phoneNumber]);
                    } else {
                      setSelectedCustomerNumbers(selectedCustomerNumbers.filter(num => num !== customer.phoneNumber));
                    }
                  }}
                />
                {customer.phoneNumber}
              </label>
            ))
          ) : (
            <p>No customers found. Please add customers via orders.</p>
          )}
        </div>
      </div>
      <div className="form-group">
        <label>Message:</label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message here..."
          className="input-field"
        />
      </div>
      <button onClick={handleSendMessage} className="send-btn" disabled={loading}>
        {loading ? 'Sending...' : 'Send Message'}
      </button>
      <button onClick={handlePreviewWhatsAppCard} className="preview-btn">Preview WhatsApp Card</button>
      {sentMessages.map((msg, index) => (
        <SentMessageCard key={index} {...msg} />
      ))}
      {previewVisible && (
        <div className="whatsapp-preview">
          <h3>WhatsApp Message Preview</h3>
          <div className="whatsapp-card">
            <p><strong>From:</strong> {vendors.find(v => v.id === Number(selectedVendorId))?.shopName || sentMessages[sentMessages.length - 1]?.vendorName || 'Vendor Name'}</p>
            {vendors.find(v => v.id === Number(selectedVendorId))?.shopImage && (
              <img
                src={`http://localhost:5002${vendors.find(v => v.id === Number(selectedVendorId))?.shopImage}`}
                alt="Vendor Image"
                className="preview-image"
                style={{ maxWidth: '100px', maxHeight: '100px' }}
                onError={(e) => console.log('Vendor Image Error:', e.target.src)}
              />
            )}
            <p><strong>Products:</strong>
              {sentMessages.length > 0 ? (
                <span>
                  {sentMessages[sentMessages.length - 1]?.products.map((p, index) => (
                    <span key={index}>
                      {p.name} - ₹{p.price}
                      {p.image && (
                        <img src={`http://localhost:5002${p.image}`} alt={p.name} style={{ maxWidth: '50px', maxHeight: '50px', marginLeft: '10px' }} onError={(e) => console.log('Product Image Error:', e.target.src)} />
                      )}
                      {index < sentMessages[sentMessages.length - 1]?.products.length - 1 && ', '}
                    </span>
                  ))}
                </span>
              ) : selectedProducts.length > 0 ? (
                <span>
                  {selectedProducts.map((p, index) => (
                    <span key={index}>
                      {p.name} - ₹{p.price}
                      {p.image && (
                        <img src={`http://localhost:5002${p.image}`} alt={p.name} style={{ maxWidth: '50px', maxHeight: '50px', marginLeft: '10px' }} onError={(e) => console.log('Product Image Error:', e.target.src)} />
                      )}
                      {index < selectedProducts.length - 1 && ', '}
                    </span>
                  ))}
                </span>
              ) : 'No products selected'}
            </p>
            <p><strong>Message:</strong> {sentMessages.length > 0 ? sentMessages[sentMessages.length - 1]?.message : message || 'No message'}</p>
            <p><strong>To:</strong> {sentMessages.length > 0 ? sentMessages[sentMessages.length - 1]?.customerNumbers.join(', ') : selectedCustomerNumbers.join(', ') || 'No customers selected'}</p>
          </div>
          <button onClick={() => setPreviewVisible(false)} className="close-btn">Close Preview</button>
        </div>
      )}
    </div>
  );
}

const SentMessageCard = ({ vendorName, products, customerNumbers, message }) => (
  <div className="sent-message-card">
    <h3>Sent Message Details</h3>
    <p><strong>Vendor:</strong> {vendorName || 'Not Available'}</p>
    <p><strong>Products:</strong>
      {products.map((p, index) => (
        <span key={index}>
          {p.name} - ₹{p.price}
          {p.image && (
            <img src={`http://localhost:5002${p.image}`} alt={p.name} style={{ maxWidth: '50px', maxHeight: '50px', marginLeft: '10px' }} onError={(e) => console.log('Product Image Error:', e.target.src)} />
          )}
          {index < products.length - 1 && ', '}
        </span>
      ))}
    </p>
    <p><strong>Customers:</strong> {customerNumbers.join(', ')}</p>
    <p><strong>Message:</strong> {message}</p>
  </div>
);

export default TypeWithCustomer;